import React from 'react';
import noop from 'lodash/noop';
import { DropdownHotkey } from '../hotkeys';

export interface DropdownStateContextProps {
  isOpen: boolean;
  setToggleRef: (node: HTMLElement | null) => void;
  setMenuRef: (node: HTMLElement | null) => void;
  openDropdown: () => void;
  closeDropdown: () => void;
  toggleDropdown: () => void;
  firstKeyInteraction: DropdownHotkey | null;
}

export const DropdownStateContext =
  React.createContext<DropdownStateContextProps>({
    isOpen: false,
    setToggleRef: noop,
    setMenuRef: noop,
    openDropdown: noop,
    closeDropdown: noop,
    toggleDropdown: noop,
    firstKeyInteraction: null,
  });
DropdownStateContext.displayName = 'DropdownStateContext';

export const DropdownDebugContext = React.createContext({
  forceOpen: false,
});
DropdownDebugContext.displayName = 'DropdownDebugContext';
